/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, date: NonNullable<unknown> }} Practice_Attempt_Option_LatestInputs */



/**
* | output |
* | --- |
* | "Attempt {number} · {date} (latest)" |
*
* @param {Practice_Attempt_Option_LatestInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_attempt_option_latest = /** @type {((inputs: Practice_Attempt_Option_LatestInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Attempt_Option_LatestInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Poging ${i?.number} · ${i?.date} (laatste)`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tentative ${i?.number} · ${i?.date} (dernière)`)
	return /** @type {LocalizedString} */ (`Attempt ${i?.number} · ${i?.date} (latest)`)
});